export default __webpack_public_path__ + "static/media/june-min.69ca8988.jpg";